var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import clsx from 'clsx';
import React from 'react';
import { varFadeInUp } from './variants';
import { motion, AnimatePresence } from 'framer-motion';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog } from '@material-ui/core'; // ----------------------------------------------------------------------

var useStyles = makeStyles(function (theme) {
  return {
    root: {},
    paper: {
      borderRadius: theme.shape.borderRadiusMd,
      backgroundColor: theme.palette.background.paper
    }
  };
});
export var DialogAnimate = function DialogAnimate(_a) {
  var _a$open = _a.open,
      open = _a$open === void 0 ? false : _a$open,
      onClose = _a.onClose,
      children = _a.children,
      className = _a.className,
      other = __rest(_a, ["open", "onClose", "children", "className"]);

  var classes = useStyles();
  return React.createElement(AnimatePresence, null, open && React.createElement(Dialog, Object.assign({
    fullWidth: true,
    maxWidth: 'xs',
    open: open,
    onClose: onClose,
    PaperComponent: motion.div,
    PaperProps: Object.assign({}, varFadeInUp),
    classes: {
      paper: classes.paper
    },
    className: clsx(classes.root, className)
  }, other), children));
};